import React from 'react'
import { FaArrowRight, FaStar } from 'react-icons/fa'
function Java_Review_Program_Page() {
  return (
    <div>
      <div>
        <div className="container">
          <div className="row d-sm-block d-md-none">
            <div className="col-md-1"></div>
            <div className="col-md-10">
              <div className="text-center review_component_text">
                <h1 className="display-5 pb-2">Testmonial</h1>
                <p className="fs-6">
                  Listen to the people who have made it! Explore the testimonies
                  of former students who attested to the life-altering effects
                  of their educational experiences.
                </p>
              </div>
            </div>
            <div className="col-md-1"></div>
          </div>
          <div className="row">
            <div className="col-md-4 pt-5">
              <div className="Program_review_comp">
                <div className="mt-5 px-5 review_component_text">
                  <h1 className="pt-5 display-6">
                    Hear What Our Students Says
                  </h1>
                  <p className="pt-4 fs-5">
                  25K+ Students have already learned with InternsElite
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-8">
              <div className="row">
                <div class="col-md-5 card">
                  <div class="card-body">
                    <h5 class="font-weight-bold">Harsh Bardhan</h5>
                    <h6 class="font-weight-bold my-2">BIT Mesra, CSE</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                    </ul>
                    <p class="">
                      <i class="fas fa-quote-left pe-2"></i>It was a great
                      learning period with my mentor Ameta Divija ma'am. The
                      curriculum was designed keeping all the students' schedule
                      on priority basis. Thanks a lot for this opportunity.
                    </p>
                  </div>
                </div>
                <div class="col-md-7 card">
                  <div class="card-body">
                    <h5 class="font-weight-bold">Akshat Jain</h5>
                    <h6 class="font-weight-bold my-2">
                      Modi Institute of Technology, CS
                    </h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar />
                      </li>
                    </ul>
                    <p class="">
                      <i class="fas fa-quote-left pe-2"></i>Internselite's
                      program is an excellent guide for Android development,
                      offering a comprehensive dive into Java essentials,
                      including XML and the Android SDK, backed by strong
                      community support.
                    </p>
                  </div>
                </div>
                <div class="col-md-6 card">
                  <div class="card-body">
                    <h5 class="font-weight-bold">Raj Shekhar Singh</h5>
                    <h6 class="font-weight-bold my-2">Lucknow University</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                    </ul>
                    <p class="mb-2">
                      <i class="fas fa-quote-left pe-2"></i>It was a great
                      experience with Internselite which gave me an opportunity
                      to do a internship with it. The internship program was
                      very good and nice Internselite were very helpful to me
                      throughout my whole internship program.
                    </p>
                  </div>
                </div>
                <div class="col-md-6 card">
                  <div class="card-body">
                    <h5 class="font-weight-bold">Sankalp Nigam</h5>
                    <h6 class="font-weight-bold my-2">
                      Shri Jai Narayan Degree College, (KKC){' '}
                    </h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar />
                      </li>
                    </ul>
                    <p class="">
                      <i class="fas fa-quote-left pe-2"></i>The sessions are
                      good .The information which is given in the sessions are
                      helpful for my future works.
                    </p>
                  </div>
                </div>
                <div class="col-md-7 card">
                  <div class="card-body">
                    <h5 class="font-weight-bold">Bhoomika Deshmukh</h5>
                    <h6 class="font-weight-bold my-2">
                      Shaildevi Mahavidyalaya Anda, Durg CG (B.Ed.)
                    </h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                    </ul>
                    <p class="">
                      <i class="fas fa-quote-left pe-2"></i>The sessions went
                      very smoothly, the guide explained everything to us in an
                      easy way and the session after session which was taken by
                      the industrial professional was also useful. It also
                      proved to be very helpful. I would like to express my
                      sincere thanks to the entire Internselite Guidance Group.
                    </p>
                  </div>
                </div>
                <div class="col-md-5 card">
                  <div class="card-body">
                    <h5 class="font-weight-bold">Kinjal Timbaliya </h5>
                    <h6 class="font-weight-bold my-2">
                      Government Engineering College Modasa, CS{' '}
                    </h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar color={'gold'} />
                      </li>
                      <li>
                        <FaStar />
                      </li>
                    </ul>
                    <p class="">
                      <i class="fas fa-quote-left pe-2"></i>I have learned very
                      much things from this internship. I learned about Android
                      Development and flutter also . It was helpful for resume
                      building, LinkedIn profile building and interview skills
                      improving also. Thankyou InternsElite Team for this
                      opportunity.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Java_Review_Program_Page
